import React from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  PoleDefault,
  LabelPole,
  LampPole,
  GroundPole,
  CableLowAwTop,
  CableAerial,
  CablePublic,
  // CableLowAwBottom,
  RelayDefault,
  RelayLabel,
  TriangleDefault,
  SwitchDefault,
  SwitchDrop,
  SwitchDAS,
  SwitchDASLabel,
  MeterDefault,
  Meter3Fase,
  GroupMeter,
  MeterHighTension,
  MeterHighTensionLabel,
  RiserTransformerDefault,
  RelayPh,
} from "../../material/icons/equipemnt";
import { NotListedLocationRounded } from "@material-ui/icons";

interface IEquipGenSymbol {
  property?: any;
}

const useStyle = makeStyles((theme: Theme) => ({
  equip: {
    width: theme.spacing(14),
    height: theme.spacing(14),
  },
}));

const EquipGenSymbol = (props: IEquipGenSymbol) => {
  const classes = useStyle();
  const {
    equip_type,
    workFunc,
    lamp,
    lampPower,
    poleSize,
    ground,
    cableType,
    relayType,
    switchType,
    meterType,
    textFill,
    ...propStyles
  } = props.property;
  return equip_type === "equip-pole" ? (
    <PoleDefault
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc !== "EX." ? 1 : 0,
      }}
    >
      {workFunc === "EX." && (
        <LabelPole
          style={{
            fontSize: "1rem",
            fill: textFill ? textFill : "#000000",
            fillOpacity: 1,
            stroke: textFill ? textFill : "#000000",
          }}
        >
          {workFunc.split(".")[0]}
        </LabelPole>
      )}
      {lamp && <LampPole />}
      {ground && <GroundPole />}
    </PoleDefault>
  ) : equip_type === "equip-cable" && cableType === "underAwning" ? (
    // <CableLowAwBottom
    //   className={classes.equip}
    //   style={{
    //     strokeWidth: propStyles.strokeWidth,
    //     stroke: propStyles.stroke,
    //     strokeOpacity: propStyles.strokeOpacity ? propStyles.strokeOpacity : 1,
    //   }}
    // />
    <CableLowAwTop
      className={classes.equip}
      style={{
        strokeWidth: propStyles.strokeWidth,
        stroke: propStyles.stroke,
        strokeOpacity: propStyles.strokeOpacity ? propStyles.strokeOpacity : 1,
      }}
    />
  ) : equip_type === "equip-cable" && cableType === "onPole" ? (
    <CableLowAwTop
      className={classes.equip}
      style={{
        strokeWidth: propStyles.strokeWidth,
        stroke: propStyles.stroke,
        strokeOpacity: propStyles.strokeOpacity ? propStyles.strokeOpacity : 1,
      }}
    />
  ) : equip_type === "equip-cable" &&
    (cableType === "aerial" || cableType === "mediumVoltageCable") ? (
    <CableAerial
      className={classes.equip}
      style={{
        strokeWidth: propStyles.strokeWidth,
        stroke: propStyles.stroke,
        strokeOpacity: propStyles.strokeOpacity ? propStyles.strokeOpacity : 1,
      }}
    />
  ) : equip_type === "equip-cable" && cableType === "public" ? (
    <CablePublic
      className={classes.equip}
      style={{
        strokeWidth: propStyles.strokeWidth,
        stroke: propStyles.stroke,
        strokeOpacity: propStyles.strokeOpacity ? propStyles.strokeOpacity : 1,
      }}
    />
  ) : equip_type === "equip-relay" && relayType === "RL" ? (
    <RelayDefault
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc !== "EX." ? 1 : 0,
      }}
    >
      <RelayLabel
        className={classes.equip}
        style={{
          fill: textFill ? textFill : "#595A5A",
          fillOpacity: 1,
        }}
      >
        {relayType}
      </RelayLabel>
    </RelayDefault>
  ) : equip_type === "equip-relay" && relayType === "PH" ? (
    <RelayPh
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc !== "EX." ? 1 : 0,
      }}
    >
      <RelayLabel
        className={classes.equip}
        style={{
          fill: textFill ? textFill : "#595A5A",
          fillOpacity: 1,
        }}
      >
        {relayType}
      </RelayLabel>
    </RelayPh>
  ) : equip_type === "equip-transformer" ? (
    <TriangleDefault
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc === "EX." ? 0 : 1,
      }}
    />
  ) : equip_type === "equip-switch" &&
    switchType === "disconnecting_normally" ? (
    <SwitchDefault
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc === "EX." ? 0 : 1,
      }}
    />
  ) : equip_type === "equip-switch" && switchType === "drop_fuse" ? (
    <SwitchDrop
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc === "EX." ? 0 : 1,
      }}
    />
  ) : equip_type === "equip-switch" && switchType === "das" ? (
    <SwitchDAS
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc === "EX." ? 0 : 1,
      }}
    >
      <SwitchDASLabel
        className={classes.equip}
        style={{
          ...propStyles,
          fill: propStyles.textFill ? propStyles.textFill : "#000000",
          fillOpacity: propStyles.textFillOpacity
            ? propStyles.textFillOpacity
            : 1,
        }}
      />
    </SwitchDAS>
  ) : equip_type === "equip-meter" && meterType === "meter1fase" ? (
    <MeterDefault
      className={classes.equip}
      style={{
        ...propStyles,
        strokeWidth: workFunc === "EX." ? 1 : 3,
      }}
    />
  ) : equip_type === "equip-meter" && meterType === "groupmeter" ? (
    <GroupMeter
      className={classes.equip}
      style={{
        ...propStyles,
        strokeWidth: workFunc === "EX." ? 1 : 3,
      }}
    />
  ) : equip_type === "equip-meter" && meterType === "high_tension_meter" ? (
    <MeterHighTension
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc === "EX." ? 0 : 1,
        strokeWidth: workFunc === "EX." ? 1 : 3,
      }}
    >
      <MeterHighTensionLabel
        className={classes.equip}
        style={{
          strokeWidth: 0,
          fontWeight: workFunc === "EX." ? 300 : 800,
          fill: textFill ? textFill : "#000000",
          fillOpacity: 1,
        }}
      />
    </MeterHighTension>
  ) : equip_type === "equip-meter" && meterType === "meter3fase" ? (
    <Meter3Fase
      className={classes.equip}
      style={{
        ...propStyles,
        strokeWidth: workFunc === "EX." ? 1 : 3,
      }}
    />
  ) : equip_type === "equip-riser-transformer" ? (
    <RiserTransformerDefault
      className={classes.equip}
      style={{
        ...propStyles,
        fillOpacity: workFunc === "EX." ? 0 : 1,
        strokeWidth: workFunc === "EX." ? 1 : 2,
      }}
    />
  ) : (
    <NotListedLocationRounded className={classes.equip} />
  );
};

export default EquipGenSymbol;
